import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IItemForGetShortInfo, IGetCategoriesShort, IGetCategoriesShortResponse } from 'types';
import { Rule } from 'antd/lib/form';
import { useFetchData } from 'hooks/useFetchData';
import FormSelect from 'components/Select/FormSelect';
import { getCategoriesShortInfo } from 'backend/categories';

interface ICategorySelect {
	setIDCategory: (value: Nullable<string>) => void;
	setFetchedCategories: (value: IItemForGetShortInfo[]) => void;
	IDsSelectedRestaurant: string[];
}

const CategorySelect: React.FC<ICategorySelect> = ({ setIDCategory, setFetchedCategories, IDsSelectedRestaurant }) => {
	const { response, loading, refetch, responseError } = useFetchData<
		IGetCategoriesShortResponse,
		IGetCategoriesShort
	>(IDsSelectedRestaurant.length ? getCategoriesShortInfo : null, { restaurantIds: IDsSelectedRestaurant });
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectCategory') }], [t]);

	useEffect(() => {
		refetch();
	}, [IDsSelectedRestaurant]);

	useEffect(() => {
		response && setFetchedCategories(response.data.categories);
	}, [response]);

	return (
		<FormSelect
			testId="CategorySelect"
			name="IDSelectedCategory"
			label="categoryLabel"
			options={response?.data.categories}
			fetchError={responseError}
			loading={loading}
			disabled={!IDsSelectedRestaurant.length}
			onRefetch={refetch}
			onChange={setIDCategory}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(CategorySelect);
